const DEFAULT_INSTAGRAM_URL = 'https://www.instagram.com/drs.farm_2024/';

export function normalizeInstagramUrl(rawUrl) {
  const raw = (rawUrl || '').trim();
  if (!raw) return DEFAULT_INSTAGRAM_URL;

  if (raw.startsWith('@')) {
    return `https://www.instagram.com/${raw.slice(1).replaceAll('/', '')}/`;
  }

  if (/^https?:\/\//i.test(raw)) {
    return raw.endsWith('/') ? raw : `${raw}/`;
  }

  if (raw.includes('instagram.com')) {
    return `https://${raw.replace(/^\/+/, '')}`;
  }

  return `https://www.instagram.com/${raw.replaceAll('/', '')}/`;
}
